import _ from "underscore";

import { API_ERROR_MESSAGE } from "@/consts/const";
import { BaseAppError } from "@/errors/base-app-error";
import i18n from "@/main";

/**
 * APIエラー基底クラス
 */
export class BaseApiError extends BaseAppError {
  /**
   * コンストラクタ
   */
  constructor(message: string) {
    super(message);
  }

  /**
   * メッセージを取得する
   */
  public getMessage(): string {
    if (!_.isString(super.getMessage())) {
      return i18n.t(API_ERROR_MESSAGE.UNKNOWN);
    }

    return super.getMessage();
  }
}
